import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { loginActions } from "../../../store/user-login.reducer";
import { translationAction } from "../../../store/external/translation-reducer/translation.reducer";
import { trueFalseToBoolean } from "../../../utils/helpers.utils";
import { setAuthToken } from "../../../utils/api.utils";
import { LOGIN_STATUS as loginStat,  PAGE_ROOT_URLS as rootURls} from "../../../utils/constant.utils";
import { UserManager } from "../../../utils";
import { RightSection } from "./login.component";
import "./login.component.css"
class Login extends Component {
   constructor(props) {
       super(props);
       this.state= {
            showLogin:false,
       }
   }
   async componentDidMount() {
        const { isSsoEnabled, oidcUser, submitCrendentials, setLanguage, login, loginSelection } = this.props;        
        if (isSsoEnabled) {
            this.setState({ showLogin: false });
            if (oidcUser != null) {
                setAuthToken(oidcUser.access_token);

                var isLoggedSuccess = await submitCrendentials(oidcUser.access_token, null);
                 if (isLoggedSuccess) {
                     await login(loginStat.external);                     
                     this.redirectToPage();
                     setLanguage();
                 }
            }
            else {               
                UserManager.signinRedirect();
            }
        }
        else {
            this.setState({ showLogin: true });
        }
     }

    redirectToPage = () => {
        const { location, isLoggingIn, history } = this.props;
        var internalPathBase = rootURls.internal.split("/")[1];
        var externalPathBase = rootURls.external.split("/")[1];

        this.setState({ isLoading: true });
        
        let recoveredPath = null;
        if (window.name && window.name.startsWith('ATEM_TARGET:')) {
            recoveredPath = window.name.replace('ATEM_TARGET:', '');
            window.name = '';
        }
        
        let targetPath = recoveredPath || sessionStorage.getItem('EntryPathName');
        
        if (!targetPath || targetPath === 'null' || targetPath === '/') {
            targetPath = location.pathname;
        }

        sessionStorage.removeItem('EntryPathName');

        var url;
        const lowerPath = targetPath.toLowerCase();
        const dealName = sessionStorage.getItem('DealName');

        if ((lowerPath.includes('login') || lowerPath.includes('signin') || lowerPath.includes('callback')) && !isLoggingIn) {
            url = sessionStorage.getItem('logInStatus') === loginStat.internal ? rootURls.internal : rootURls.external;
        } else {           
            if (lowerPath.includes('external/inventory') === false) {
                var url = targetPath;
                if (dealName && dealName !== 'null') url = targetPath.replace(/^(\/.*?\/)([^/]+)/gm, '$1' + dealName);
                
                if (targetPath.split("/")[1] === internalPathBase && sessionStorage.getItem('logInStatus') !== loginStat.internal) {
                    url = rootURls.external;
                }
                if (targetPath.split("/")[1] === externalPathBase && sessionStorage.getItem('logInStatus') !== loginStat.external) {
                    url = rootURls.internal;
                }
            }
            else {
                url = targetPath;
                history.push(url);
                return;
            }
            
            if (lowerPath.includes('external/invoices') === false) {
                var url = targetPath;
                if (dealName && dealName !== 'null') url = targetPath.replace(/^(\/.*?\/)([^/]+)/gm, '$1' + dealName);

                if (targetPath.split("/")[1] === internalPathBase && sessionStorage.getItem('logInStatus') !== loginStat.internal) {
                    url = rootURls.external;
                }
                if (targetPath.split("/")[1] === externalPathBase && sessionStorage.getItem('logInStatus') !== loginStat.external) {
                    url = rootURls.internal;
                }
            }
            else {
                url = targetPath;
                history.push(url);
                return;
            }

            if (lowerPath.includes('external/invoice') === false) {
                var url = targetPath;
                if (dealName && dealName !== 'null') url = targetPath.replace(/^(\/.*?\/)([^/]+)/gm, '$1' + dealName);

                if (targetPath.split("/")[1] === internalPathBase && sessionStorage.getItem('logInStatus') !== loginStat.internal) {
                    url = rootURls.external;
                }
                if (targetPath.split("/")[1] === externalPathBase && sessionStorage.getItem('logInStatus') !== loginStat.external) {
                    url = rootURls.internal;
                }
            }
            else {
                url = targetPath;
                history.push(url);
                return;
            }

            if (lowerPath.includes('hrmanagement') === false) {
                var url = targetPath;
                if (dealName && dealName !== 'null') url = targetPath.replace(/^(\/.*?\/)([^/]+)/gm, '$1' + dealName);

                if (targetPath.split("/")[1] === internalPathBase && sessionStorage.getItem('logInStatus') !== loginStat.internal) {
                    url = rootURls.external;
                }
                if (targetPath.split("/")[1] === externalPathBase && sessionStorage.getItem('logInStatus') !== loginStat.external) {
                    url = rootURls.internal;
                }
            }
            else {
                url = targetPath;
                history.push(url);
                return;
            }

            if (lowerPath.includes('orders') === false) {
                var url = targetPath;
                if (dealName && dealName !== 'null') url = targetPath.replace(/^(\/.*?\/)([^/]+)/gm, '$1' + dealName);

                if (targetPath.split("/")[1] === internalPathBase && sessionStorage.getItem('logInStatus') !== loginStat.internal) {
                    url = rootURls.external;
                }
                if (targetPath.split("/")[1] === externalPathBase && sessionStorage.getItem('logInStatus') !== loginStat.external) {
                    url = rootURls.internal;
                }
            }
            else {
                url = targetPath;
                history.push(url);
                return;
            }

            if (lowerPath.includes('finance') === false) {
                var url = targetPath;
                if (dealName && dealName !== 'null') url = targetPath.replace(/^(\/.*?\/)([^/]+)/gm, '$1' + dealName);

                if (targetPath.split("/")[1] === internalPathBase && sessionStorage.getItem('logInStatus') !== loginStat.internal) {
                    url = rootURls.external;
                }
                if (targetPath.split("/")[1] === externalPathBase && sessionStorage.getItem('logInStatus') !== loginStat.external) {
                    url = rootURls.internal;
                }
            }
            else {
                url = targetPath;
                history.push(url);
                return;
            }
            
            if (lowerPath.includes('recharging') === false) {
                var url = targetPath;
                if (dealName && dealName !== 'null') url = targetPath.replace(/^(\/.*?\/)([^/]+)/gm, '$1' + dealName);

                if (targetPath.split("/")[1] === internalPathBase && sessionStorage.getItem('logInStatus') !== loginStat.internal) {
                    url = rootURls.external;
                }
                if (targetPath.split("/")[1] === externalPathBase && sessionStorage.getItem('logInStatus') !== loginStat.external) {
                    url = rootURls.internal;
                }
            }
            else {
                url = targetPath;
                history.push(url);
                return;
            }
        }
        history.push(url);
    };

    showLoginForm = (showItem) => {
        this.setState({showLogin:showItem})
   }

    render(){
        const {isSsoEnabled,
            submitCrendentials,
            loginSelection,
            login,
            isLoggingIn,
            isLoggingOut,
            isClientUser,
            hasUserScope,
            isLoginError, 
            setLanguage
        } = this.props;
        return(
            <div>
                {!isLoggingIn && !isLoggingOut &&
                    <div className="login-container">
                        <div className="login-left-container">
                            <div className="blue-img" />
                            <h1 className="login-header">Welcome to</h1>
                            <h1 className="login-header login-header-brand">ATEM</h1>
                            <span className="login-sub-text">
                                Accenture Technology Expense Management
                            </span>
                        </div>
                        <div className="login-right-container">
                            {
                                !hasUserScope && !isSsoEnabled &&
                                <RightSection
                                    onLoginFormSubmitted={this.showLoginForm}
                                    submitCrendentials={submitCrendentials}
                                    hasUserScope={hasUserScope}
                                    isClientUser={isClientUser}
                                    login={login}
                                    loginSelection={loginSelection}
                                    redirectToPage={this.redirectToPage}
                                    isLoginError={isLoginError}
                                    setLanguage={setLanguage}
                                />
                            }
                        </div>
                    </div>
                }
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch,
        ...bindActionCreators(Object.assign({}, loginActions, translationAction), dispatch)
    }
}

function mapStateToProps(state) {
    const { oidc, login, authentication, history, translation } = state;
        return {
            oidcUser: oidc && oidc.user,
            isSsoEnabled: trueFalseToBoolean(process.env.REACT_APP_AAD_AUTH_ENABLE),
            externalRedirectionEnabled: trueFalseToBoolean(process.env.REACT_APP_EXTERNAL_REDIRECTION),
            redirectInternalUrl: process.env.REACT_APP_INTERNAL_REDIRECTION_URL,
            ...login,
            ...authentication,
            ...history,
            ...translation
        };
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);